module.exports = __webpack_public_path__ + "static/media/hospital.03ba1c32.svg";